<template>
  <FormCard :title="mode === 'edit' ? 'Данные менеджера' : 'Менеджер'" source="customer">
    <FormGrid :cols="singleColumn ? 1 : 2">
      <FormField
        label="Имя"
        :invalid="(!form.name.valid && form.name.tochted) || !!errors.name"
        :error="errors.name || fieldError(form.name)"
      >
        <input
          id="manager-name"
          v-model="form.name.value"
          type="text"
          :class="{ invalid: errors.name }"
          @blur="form.name.blur"
        />
      </FormField>
      <FormField
        label="Номер телефона"
        help="Номер страны СНГ с международным кодом"
        :invalid="(!form.phone.valid && form.phone.tochted) || !!errors.phone"
        :error="errors.phone || fieldError(form.phone)"
      >
        <input
          id="manager-phone"
          :value="form.phone.value"
          type="text"
          :class="{ invalid: errors.phone }"
          @input="onPhoneInput"
          @blur="form.phone.blur"
        />
      </FormField>
      <FormField
        label="Email"
        :invalid="(!form.email.valid && form.email.tochted) || !!errors.email"
        :error="errors.email || fieldError(form.email)"
      >
        <input
          id="manager-email"
          v-model="form.email.value"
          type="text"
          :class="{ invalid: errors.email }"
          @blur="form.email.blur"
        />
      </FormField>
    </FormGrid>

    <div v-if="serverError" class="server-error">{{ serverError }}</div>

    <div class="form-actions">
      <my-shrunk-button
        @click="sendForm"
        :btnSettings="{shrunk:true,name:''}"
      >{{ mode === 'edit' ? 'Сохранить' : 'Создать' }}</my-shrunk-button>
      <my-shrunk-button
        class="cancel-btn bg-denied"
        @click="closeForm"
        :btnSettings="{shrunk:true,name:''}"
      >Отменить</my-shrunk-button>
    </div>
  </FormCard>
</template>


<script>
import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useForm, useFormat, touchForm } from '@/hooks/form'


export default {
  name: 'ManagerForm',
  props: {
    companyId: { type: [String, Number], default: null },
    mode: { type: String, default: 'create' },
    initialData: { type: Object, default: () => ({}) },
    errors: { type: Object, default: () => ({}) },
    singleColumn: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const store = useStore()
    const isEdit = computed(() => props.mode === 'edit')

    const form = useForm({
      name: {
        value: '',
        validators: ['required'],
      },
      phone: {
        value: '',
        validators: ['required', 'phone'],
      },
      email: {
        value: '',
        validators: ['required', 'email'],
      },
    })

    const fillInitialData = (source = {}) => {
      if (!isEdit.value) return
      form.name.value = source.name || ''
      form.phone.value = source.phone || ''
      form.email.value = source.email || ''
    }
    watch(() => props.initialData, fillInitialData, { immediate: true })

    const serverError = computed(() => store.state.apiStorage.managers?.formErrors?._form || '')
    const fieldError = (field) => field.tochted
      ? Object.values(field.errors).find(Boolean) || ''
      : ''
    const submitted = ref(false)

    const onPhoneInput = (event) => {
      const cleaned = (event.target.value || '').replace(/\D/g, '')
      form.phone.value = cleaned
    }

    const sendForm = async () => {
      if (!await touchForm(form)) return
      store.commit('apiStorage/setFormErrors', { model: 'managers', errors: {} })
      const payload = useFormat(form)
      if (isEdit.value) {
        if (props.initialData?.id != null) payload.id = props.initialData.id
        emit('update', payload)
        return
      }
      if (props.companyId != null) payload.company_id = props.companyId
      emit('sendForm', { model: 'managers', form: payload })
    }

    const closeForm = () => {
      emit('closeForm')
    }

    return {
      form,
      fieldError,
      sendForm,
      onPhoneInput,
      closeForm,
      serverError,
      submitted,
      mode: props.mode,
      errors: props.errors,
    }
  },
}
</script>


<style scoped>
.form-actions {
  display: flex;
  gap: 20px;
  margin-top: 12px;
}

.cancel-btn {
  margin-left: 0;
}

.server-error {
  color: #dc3545;
  font-size: 13px;
  text-align: center;
  padding: 6px 8px;
  border: 1px solid #dc3545;
  border-radius: 4px;
  background: #fff5f5;
  margin-bottom: 12px;
}
</style>
